import {
  FilterMode,
  GrossReceiptsStatusCreateMutationVariables,
  GrossReceiptsStatus_OrderBy,
  GrossReceiptsStatus,
  SortOrder,
  GrossReceiptsStatus_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const grossReceiptsStatusService = {
  createOne: buildCreateOne(
    (
        grossReceiptsStatusCreateVariables: GrossReceiptsStatusCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.grossReceiptsStatusCreate(
          grossReceiptsStatusCreateVariables
        );
        return result.grossReceiptsStatusCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.grossReceiptsStatusOne({ id });
    return result.grossReceiptsStatusOne as GrossReceiptsStatus;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: GrossReceiptsStatus_OrderBy[] | null = null,
    filter: GrossReceiptsStatus_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: GrossReceiptsStatus_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.grossReceiptsStatusListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.grossReceiptsStatusListWithOffset
    ) as GrossReceiptsStatus[];
    return { list, orderBy };
  },
};
